<script setup>
import { computed } from 'vue';

const props = defineProps({
    // Classes da coluna em volta do card.
    classeColuna: {
        type: String,
        default: 'col-12'
    },
    titulo: {
        type: String,
        default: ''
    },
    // Texto em destaque. Para conteúdo formatado, use o slot padrão.
    valor: {
        type: [String, Number],
        default: null
    },
    // Exibe o valor na mesma linha do título (ex.: "Contrato: Fulano").
    emLinha: {
        type: Boolean,
        default: false
    },
    // Observação em letra menor abaixo do valor. Também aceita o slot #aviso.
    aviso: {
        type: String,
        default: null
    },
    iconeAviso: {
        type: String,
        default: 'pi pi-info-circle'
    },
    // Ícone à esquerda do conteúdo, na cor da severidade.
    icone: {
        type: String,
        default: null
    },
    // Destaque do card: 'neutro', 'info', 'alerta', 'sucesso' ou 'erro'.
    severidade: {
        type: String,
        default: 'neutro',
        validator: (valor) => ['neutro', 'info', 'alerta', 'sucesso', 'erro'].includes(valor)
    }
});

const estilos = {
    neutro: { card: 'surface-border', icone: 'text-500' },
    info: { card: 'border-blue-300 bg-blue-50', icone: 'text-blue-500' },
    alerta: { card: 'border-yellow-300 bg-yellow-50', icone: 'text-yellow-500' },
    sucesso: { card: 'border-green-500 bg-green-50', icone: 'text-green-500' },
    erro: { card: 'border-red-300 bg-red-50', icone: 'text-red-500' }
};

const estilo = computed(() => estilos[props.severidade]);
</script>

<template>
    <div :class="props.classeColuna">
        <div class="border-1 p-3 border-round-md flex align-items-center gap-3" :class="estilo.card">
            <i v-if="props.icone" :class="[props.icone, estilo.icone]"></i>
            <p class="m-0 text-700 text-sm line-height-3">
                <template v-if="props.titulo">
                    {{ props.titulo }}{{ props.emLinha ? ' ' : '' }}<br v-if="!props.emLinha">
                </template>
                <span class="text-900 font-semibold">
                    <slot>{{ props.valor }}</slot>
                </span>
                <template v-if="props.aviso || $slots.aviso">
                    <br>
                    <span class="text-xs flex flex-row align-items-center gap-2">
                        <span :class="[props.iconeAviso, 'text-xs']"></span>
                        <slot name="aviso">{{ props.aviso }}</slot>
                    </span>
                </template>
            </p>
        </div>
    </div>
</template>
